// extracted by mini-css-extract-plugin
export default {"buttonContainer":"t5-t2","alignToEdge":"tz-wU","buttonIcon":"IeMkd","buttonCaption":"_9gEd-","buttonSpacer":"P9jVt"};